export const userStates = Object.freeze({
  nil: 'nil',
  waitingForApproval: 'waiting_for_approval',
  approved: 'approved',
  rejected: 'rejected'
})

export const userTypes = Object.freeze({
  general: 'general',
  syndicate: 'syndicate',
  company: 'company',
  individual: 'individual',
  not_verified: 'not_verified'
})

export const userStatesNum = Object.freeze({
  nil: 1,
  waitingForApproval: 2,
  approved: 4,
  rejected: 8
})
export const KYC_USER_TYPE = Object.freeze({
  general: 'general',
  syndicate: 'syndicate',
  individual: 'individual',
  company: 'company',
  not_verified: 'not_verified'
})



// WEBPACK FOOTER //
// ./src/js/const/user.const.js